type StuffIdTypeSource = {
  tp?: string | number | null
  sg?: string | number | null
}

type ProductType = 1 | 2

const getTypeFromValue = (value: string | number | null | undefined): ProductType | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }

  const normalized = value.toString().trim().toLocaleLowerCase('en-US')
  if (normalized.includes('خدمت') || normalized.includes('service')) {
    return 2
  }
  if (
    normalized.includes('کالا') ||
    normalized.includes('product') ||
    normalized.includes('goods')
  ) {
    return 1
  }

  const numericType = Number(normalized)
  if (numericType === 1 || numericType === 4) {
    return 1
  }
  if (numericType === 2 || numericType === 5) {
    return 2
  }

  return undefined
}

const getProductTypeFromStuffId = (
  stuffId: StuffIdTypeSource | null | undefined
): ProductType | undefined => {
  const type = getTypeFromValue(stuffId?.tp)
  if (type) {
    return type
  }

  const fileNumber = Number(stuffId?.sg)
  if (fileNumber === 5) {
    return 2
  }
  if (Number.isInteger(fileNumber) && fileNumber >= 1 && fileNumber <= 4) {
    return 1
  }

  return undefined
}

export {getProductTypeFromStuffId}
export type {ProductType}
